'use client';
import { ResponseModuleStoreFront } from '@/src/interfaces/data-contracts';
import { InnerContainer } from '../../ui/common/inner-container';
import RecommendedLoanCard from './recommended-loan-card';
import { useContext, useMemo } from 'react';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { Pages } from '@/src/interfaces/pages-route';

type Props = {
  recommendedLoans: ResponseModuleStoreFront | undefined;
  maturities: Pages.SmeHomeList.ResponseBody['maturities'];
  showDetails?: boolean;
  checkActiveRecourseForApply?: boolean;
  useResponseApplyLink?: boolean;
  typeId: number;
  path?: string | null;
};

const RecommendedLoans: React.FC<Props> = ({
  recommendedLoans,
  maturities,
  showDetails,
  checkActiveRecourseForApply,
  useResponseApplyLink,
  typeId,
}) => {
  const { isMobile } = useContext(DeviceContext);

  const productsToList = useMemo(() => {
    const sorted = recommendedLoans?.products?.sort((a, b) => a.displayOrder! - b.displayOrder!) || [];
    return isMobile ? sorted : sorted.slice(0, 3);
  }, [recommendedLoans, isMobile]);

  if (productsToList.length === 0) {
    return <></>;
  }

  return (
    <div data-testid="recommendedLoans">
      <InnerContainer>
        <div className="text-lg font-semibold leading-[32px] md:text-2xl">
          {recommendedLoans?.name ?? 'Tavsiye Ettiğimiz Krediler'}
        </div>
      </InnerContainer>
      <ul
        className="flex overflow-auto px-4 pb-8 pt-5 md:px-[calc((100%_-_1120px)/2)] md:pb-[72px] md:pt-8"
        data-testid="recommendedLoanList"
      >
        {productsToList.map((product) => (
          <RecommendedLoanCard
            key={product.productId}
            product={product}
            maturities={maturities}
            showDetails={showDetails}
            checkActiveRecourseForApply={checkActiveRecourseForApply}
            useResponseApplyLink={useResponseApplyLink}
            typeId={typeId}
          />
        ))}
      </ul>
    </div>
  );
};

export default RecommendedLoans;
